// extracted by mini-css-extract-plugin
export default {"cityContainer":"MainPage_cityContainer__-rmbf","emptyContainer":"MainPage_emptyContainer__i9w6b","addItemForm":"MainPage_addItemForm__znxCj"};